import React from 'react';
import { useMutation } from 'react-query';

import { adminAPI } from '../../../../api';
import useModal from '../../../../context/ModalContext';
import useAlarm from '../../../../context/AlarmContext';
import FormLoader from '../../../../components/FormLoader';

const RemoveModalParticipant = ({ ids, cohortId, refetch, refetchParticipants, setCheckedParticipants, checkedAllParticipants, filter }) => {
  const { setAlarm } = useAlarm();
  const { closeModal } = useModal();

  const { mutate: removeParticipantsMutation, isLoading: isRemoving } = useMutation(
    adminAPI.removeParticipantsFromCohort,
    {
      onSuccess: (data) => {
        refetch();
        if (data && data.processing) {
          setAlarm({ type: 'success', message: data.message });
        } else {
          const removedCountMsg = checkedAllParticipants ? 'Participants' : `Participant${ids.length !== 1 ? 's' : ''}`;
          setAlarm({ type: 'success', message: `${removedCountMsg} removed successfully` });
        }
        refetchParticipants();
        setCheckedParticipants([]);
        closeModal();
      },
      onError: (error) => {
        setAlarm({ type: 'error', message: error.message });
        closeModal();
      },
    }
  );

  const handleSubmit = (event) => {
    event.preventDefault();
    if (checkedAllParticipants) {
      removeParticipantsMutation({ id: cohortId, cohort: { userEmails: [] }, filter });
    } else {
      removeParticipantsMutation({ id: cohortId, cohort: { userEmails: ids.map((participant) => participant.email) } });
    }
  };

  return (
    <>
      <form onSubmit={handleSubmit}>
        <div className="flex justify-between">
          <strong>Are you sure you want to remove {ids.length > 1 || checkedAllParticipants ? 'these participants' : 'this participant'}?</strong>
          <div className="flex justify-end">
            <button
              type="button"
              onClick={closeModal}
              className="font-semibold p-4 rounded-lg bg-gray text-black mr-2"
            >
              No
            </button>
            <button
              type="submit"
              className="font-semibold p-4 rounded-lg bg-red text-white"
              disabled={isRemoving}
            >
              {isRemoving ? 'Removing...' : 'Yes'}
            </button>
          </div>
        </div>
      </form>
      {isRemoving && <FormLoader />}
    </>
  );
};

export default RemoveModalParticipant;
